/*
 * UserList Messages
 *
 * This contains all the text for the UserList component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.containers.DepotCreate.title',
    defaultMessage: 'Create Depot',
  },
  saveButton: {
    id: 'app.containers.DepotCreate.saveButton',
    defaultMessage: 'Save',
  },
  saveSuccess: {
    id: 'app.containers.DepotCreate.saveSuccess',
    defaultMessage: 'Depot has been successfully created.',
  },
  saveFailure: {
    id: 'app.containers.DepotCreate.saveFailure',
    defaultMessage: 'Error. The depot could not be created.',
  },
});
